<select class="form-control" [ngModel]="selectedOption" role="listbox" (change)="valueToggled($event)">
    <option *ngFor="let option of values" role="option" [value]="option">{{option}}</option>
</select>
